import { render, staticRenderFns } from "./SubItem.vue?vue&type=template&id=51e7f2aa&scoped=true&"
import script from "./SubItem.vue?vue&type=script&lang=js&"
export * from "./SubItem.vue?vue&type=script&lang=js&"
import style0 from "./SubItem.vue?vue&type=style&index=0&id=51e7f2aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7f2aa",
  null
  
)

export default component.exports